export function opCompact(){

}